import styled from "styled-components";

export const BaseComp = styled.div`
  display: flex;
  padding: 3%;
  @media only screen and (max-width: 800px) {
    padding: 5%;
  }
`;

export const BaseContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SidebySideContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const TextContent = styled.div`
  padding: 1% 0 1% 0;
`;

export const TextBody = styled.div`
  padding: 10px 0;
`;

export const TextTitle = styled.div`
  h1 {
    font-size: 36px;
    color: var(--purple-dark);
  }
`;

export const ImageViewport = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  margin-top: 1.5rem;
`;

export const ImageContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
  padding-bottom: 2rem;
  will-change: transform;

  animation: marquee 20s linear infinite;

  .marquee {
    width: 100%;
    white-space: nowrap;  
    overflow: hidden;
    position: relative;
  }


  .imagens {
    flex: 0 0 350px; 
    height: 420px;
    max-width: 400px;
    object-fit: cover;
    border: 3px solid #e5b930;
    background-color: #e5b930;
    border-radius: 2rem;
  }

  @keyframes marquee {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-100%); }
  }


  @media only screen and (max-width: 1000px) {
    .imagens {
      flex: 0 0 260px;
      height: 200px;
      display: inline-block; 
      animation: marquee 15s linear infinite;
    }
  }
`;